import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Button } from "@chakra-ui/react";

const ConfirmModal = ({ title, message, isOpen, onClose, onConfirm, isLoading }) => {

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    {title}
                </ModalHeader>
                <ModalCloseButton color={"black"}/>
                <ModalBody>
                    <div>
                        {message}
                    </div>
                    <div 
                        className="d-flex" 
                        style={{marginTop: "20px", marginBottom: "20px"}}
                    >
                        <Button 
                            colorScheme="blue" 
                            onClick={onConfirm} 
                            isLoading={isLoading}
                            loadingText="Procesando..."
                            disabled={isLoading}
                            mr={3}
                            ml={"auto"}
                        >
                            Confirmar
                        </Button>
                        <Button colorScheme="red" onClick={onClose}>
                            Cancelar
                        </Button>
                    </div>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

export default ConfirmModal;